import React, { useState } from 'react';
import { Window, WindowHeader, WindowContent, TextInput, Button, Select } from 'react95';
import './AddTaskModal.scss';
import { useCreateTaskMutation } from '../../api/opsSystemApi';
import { SSN_REQUIRED_TYPES, TASK_TYPES } from '../../constants';

/** Options for the stage dropdown */
const STAGE_OPTIONS = [
  { label: 'Tax Expert Escalations', value: 'Tax Expert Escalations' },
  { label: 'Filed with IRS', value: 'Filed with IRS' },
  { label: 'Accepted by IRS', value: 'Accepted by IRS' }
];

const AddTaskModal = ({ onClose }) => {
  const [userId, setUserId] = useState('');
  const [year, setYear] = useState(new Date().getFullYear() - 1);
  const [stage, setStage] = useState('Tax Expert Escalations');
  const [type, setType] = useState(TASK_TYPES.STANDARD);
  const [ssn, setSsn] = useState('');
  const [createTask] = useCreateTaskMutation();

  const generateYearOptions = () => {
    const currentYear = new Date().getFullYear();
    const startYear = 2021;
    const endYear = currentYear - 1;

    return Array.from({ length: endYear - startYear + 1 }, (_, index) => {
      const year = endYear - index;
      return { label: year.toString(), value: year };
    });
  };

  const handleSubmit = async () => {
    const requestData = { userId, year, type, stage, ssn };

    try {
      await createTask(requestData);
      onClose();
    } catch (error) {
      console.error('Failed to create task:', error);
      console.error('Error details:', {
        status: error?.status,
        data: error?.data,
        message: error?.message,
        originalStatus: error?.originalStatus
      });
    }
  };

  const handleChangeType = (opt) => {
    setType(opt.value);
  };

  return (
    <Window className='add-task-modal'>
      <WindowHeader className='add-task-modal-header'>
        <span>Add Task</span>
        <Button primary square size='sm' onClick={onClose}>
          X
        </Button>
      </WindowHeader>
      <WindowContent className='add-task-modal-body'>
        <div className='add-task-modal-field'>
          <label>User ID:</label>
          <TextInput value={userId} onChange={(e) => setUserId(e.target.value)} />
        </div>
        <div className='add-task-modal-field'>
          <label>Tax year</label>
          <Select options={generateYearOptions()} value={year} width={150} onChange={(opt) => setYear(opt.value)} />
        </div>
        <div className='add-task-modal-field'>
          <label>Stage:</label>
          <Select options={STAGE_OPTIONS} value={stage} width={200} onChange={(opt) => setStage(opt.value)} />
        </div>
        <div className='add-task-modal-field'>
          <label>Task Type</label>
          <Select
            options={[
              { label: '1040', value: TASK_TYPES.STANDARD },
              { label: 'Amendment', value: TASK_TYPES.AMENDMENT },
              { label: 'S Corp', value: TASK_TYPES.S_CORP },
              { label: 'Partnership', value: TASK_TYPES.PARTNERSHIP },
              { label: 'Consultation', value: TASK_TYPES.CONSULTATION },
              { label: 'Payroll', value: TASK_TYPES.PAYROLL },
              { label: 'Foreign', value: TASK_TYPES.FOREIGN },
              { label: 'Estate', value: TASK_TYPES.ESTATE },
              { label: 'Other', value: TASK_TYPES.OTHER }
            ]}
            value={type}
            width={150}
            onChange={handleChangeType}
          />
        </div>
        {SSN_REQUIRED_TYPES.includes(type) && (
          <div className='add-task-modal-field'>
            <label>SSN:</label>
            <TextInput value={ssn} onChange={(e) => setSsn(e.target.value)} />
          </div>
        )}
        <Button
          primary
          onClick={handleSubmit}
          disabled={
            !userId ||
            !year ||
            !type ||
            (SSN_REQUIRED_TYPES.includes(type) && String(ssn).replace(/\D/g, '').length < 9)
          }>
          Create
        </Button>
      </WindowContent>
    </Window>
  );
};

export default AddTaskModal;
